import { default as NextLink } from "next/link"

export type LinkProps = Parameters<typeof NextLink>[0]

export const Link = (props: LinkProps) => <NextLink prefetch={props.prefetch ?? false} {...props} />
